export default __webpack_public_path__ + "static/134-374d86b98e6dfe6e8b9cf51481c28c6c.jpg";